// extracted by mini-css-extract-plugin
module.exports = {"card":"Payouts_card__GX4hN"};